export default __webpack_public_path__ + "static/media/electric-wires.b6722f6b.jpg";